import { LoaderFunctionArgs } from 'react-router-dom';
import { fetchSupplier, mapSupplierToValues } from '../SuppliersPage/services';

export const supplierLoader = async ({ params }: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') return { data: null };

  try {
    const supplier = await fetchSupplier({ id });
    if (!supplier) return { data: null };
    return { data: mapSupplierToValues(supplier) };
  } catch {
    return { data: null };
  }
};
